import type { FormField } from '@/types/api/form'
import { FormFieldType } from '@/types/enums'

export const BUTTON_COLORS = ['primary', 'success', 'warning', 'danger', 'neutral'] as const
export type ButtonColor = (typeof BUTTON_COLORS)[number]

/** Matches the backend's limit on the confirmation message. */
export const BUTTON_CONFIRM_MAX = 300

export interface ButtonOptions {
  buttonColor: ButtonColor
  confirm: boolean
  confirmMessage: string
  oneShot: boolean
}

export function isButtonField(field: { type?: string }): boolean {
  return field.type === FormFieldType.BUTTON
}

/** Settings of a BUTTON field, with the defaults for whatever the designer left unset. */
export function buttonOptions(field: Pick<FormField, 'options'>): ButtonOptions {
  const o = (field.options ?? {}) as Record<string, unknown>
  return {
    buttonColor: BUTTON_COLORS.find((c) => c === o.buttonColor) ?? 'primary',
    confirm: o.confirm === true,
    confirmMessage: typeof o.confirmMessage === 'string' ? o.confirmMessage : '',
    oneShot: o.oneShot === true,
  }
}
